import React from "react";
import styled from "styled-components";
import * as Icon from "../../../../TEMPLATE/components/Map/smartiscity/Icons";

function AmeaButtons({
  selectedCategory,
  visibleRightSide,
  visibleLeftSide,
  resetSelectedItem,
}) {
  return (
    <CategoryToggleButtonWrapper
      $isRightSideVisible={visibleRightSide}
      $isLeftSideVisible={visibleLeftSide}
    >
      <CategoryButton
        $buttonName="routes"
        $activeName={selectedCategory.get}
        onClick={() => {
          selectedCategory.set("routes");
          resetSelectedItem();
        }}
      >
        <img src={Icon.defaultRoutes} />
        <span>Διαδρομές</span>
      </CategoryButton>
      <CategoryButton
        $buttonName="infra"
        $activeName={selectedCategory.get}
        onClick={() => {
          selectedCategory.set("infra");
          resetSelectedItem();
        }}
      >
        <img src={Icon.defaultMarker} />
        <span>Υποδομές</span>
      </CategoryButton>
    </CategoryToggleButtonWrapper>
  );
}

export default AmeaButtons;

const CategoryToggleButtonWrapper = styled.div`
  position: absolute;
  top: 100px;
  left: ${(props) =>
    props.$isRightSideVisible && props.$isLeftSideVisible
      ? "40%"
      : !props.$isRightSideVisible && props.$isLeftSideVisible
      ? "50%"
      : props.$isRightSideVisible && !props.$isLeftSideVisible
      ? "30%"
      : "38%"};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  transition: all 1s ease;
  z-index: 2;

  @media only screen and (max-width: 908px) {
    position: relative;
    width: 100%;
    height: 56px;
    justify-content: center;
    background-color: #f5f5f5;
    top: 0;
    left: 0;
    gap: unset;
    transition: unset;
  }
`;

const CategoryButton = styled.button`
  width: 180px;
  height: 44px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 38px;
  border: ${(props) =>
    props.$activeName === props.$buttonName ? "unset" : "1px solid #27AAE1"};
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.1);
  background-color: ${(props) =>
    props.$activeName === props.$buttonName ? "#27AAE1" : "#fff"};
  &:hover {
    border: none;
    background-color: ${(props) =>
      props.$activeName === props.$buttonName ? "#27AAE1" : "#e6e1e1"};
    transition: all 0.5s ease;
  }

  @media only screen and (max-width: 908px) {
    width: calc(100vw / 2);
    height: 100%;
    z-index: 4;
    //  border: 2px solid #f5f5f5;
    border-radius: unset;
  }
`;
